// Guaubuelo: precarga las recomendaciones de la ficha cuando la página ya ha cargado.
// Horizon solo las pide a 400 px de entrar en pantalla y, en escritorio, se pintaban ya
// a la vista y una tarjeta saltaba de columna (CLS). Su componente vuelve a cargar al
// cambiar un atributo y no repite la carga si ya está hecha (data-recommendations-performed).
(() => {
  const precargar = () => {
    document
      .querySelectorAll('product-recommendations:not([data-recommendations-performed="true"])')
      .forEach((recos) => recos.setAttribute('data-gb-precarga', ''));
  };
  const cuandoPueda = () => (window.requestIdleCallback ? requestIdleCallback(precargar, { timeout: 1500 }) : setTimeout(precargar, 300));
  if (document.readyState === 'complete') cuandoPueda();
  else window.addEventListener('load', cuandoPueda, { once: true });
})();
